import { render, staticRenderFns } from "./contrats.vue?vue&type=template&id=552b0774&"
import script from "./contrats.vue?vue&type=script&lang=js&"
export * from "./contrats.vue?vue&type=script&lang=js&"
import style0 from "./contrats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports